module.exports = __webpack_public_path__ + "img/ladyeve.2fa7400f.jpg";